<template>
  <a-modal
    :title="title"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleVisible"
    width="880px"
  >
    <template>
      <a-form :colon="false" v-bind="formItemLayout" v-show="currentKey == 1">
        <a-form-item label="导入文件 :">
          <a-upload-dragger
            style="width: 300px"
            name="file"
            :file-list="fileList"
            accept=".zip,.rar"
            :headers="headers"
            :action="uploadAction"
            @change="handleFileChange"
            @before-upload="beforeUpload"
            v-decorator="['noticeFile', { rules: [{ require: true }] }]"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">点击或拖拽上传文件</p>
          </a-upload-dragger>
        </a-form-item>
        <a-form-item label=" ">
          <span class="tips">只能上传 zip/rar 文件</span>
        </a-form-item>
      </a-form>

      <a-table
        :columns="columns"
        rowKey="id"
        bordered
        :scroll="{ x: 1200 }"
        :data-source="dataSource"
        :pagination="false"
        v-show="currentKey == 2"
      >
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="onDelete(record.id)">删除</a>
        </template>
      </a-table>
    </template>
  </a-modal>
</template>
<script>
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { jsonAction } from '@/api/manage';
const columns = [
  {
    align: 'center',
    title: '文件名称',
    dataIndex: 'attachment',
    ellipsis: true,
    width: 200,
  },
  {
    align: 'center',
    title: '公告标题',
    dataIndex: 'title',
    ellipsis: true,
    width: 200,
  },
  {
    align: 'center',
    title: '关联产品',
    dataIndex: 'fundCode',
    ellipsis: true,
    width: 200,
  },

  {
    align: 'center',
    title: '公告类型',
    dataIndex: 'category',
    width: 200,
  },
  {
    align: 'center',
    title: '上架渠道栏目',
    dataIndex: 'channelCode',
    ellipsis: true,
    width: 200,
  },
  {
    align: 'center',
    title: '发布时间',
    dataIndex: 'publishTime',
    ellipsis: true,
    width: 200,
  },
  {
    align: 'center',
    title: '导入状态',
    dataIndex: 'importState',
    ellipsis: true,
    width: 200,
  },
  {
    align: 'center',
    title: '失败原因',
    dataIndex: 'reason',
    ellipsis: true,
    width: 200,
    customRender: (text) => {
      return !text || text == '' ? '--' : text;
    },
  },
  {
    align: 'center',
    title: '操作',
    key: 'operation',
    width: 200,
    fixed: 'right',
    scopedSlots: {
      customRender: 'operation',
    },
  },
];
export default {
  data() {
    return {
      columns,
      visible: false,
      title: '导入',
      fileList: [],
      headers: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      uploadAction:
        process.env.VUE_APP_LOCAL_PATH +
        '/' +
        process.env.VUE_APP_CMS_CONTENT +
        '/content/notice/importZip',
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
      dataSource: [
        {
          pageNo: 1,
          pageSize: 10,
          id: '1508362465989697537',
          title: '国泰君安君得利集合资产管理计划2017年第4季度管理人报告',
          category: '普通公告',
          noticeType: null,
          regularType: null,
          fundCode: 'V33333',
          content: '请详见附件内容！',
          successNumber: 1,
          failNumber: 0,
          publishTime: '2022-03-31',
          parentFundCode: null,
          channelCode: '产品公告',
          columnCode: null,
          isReview: null,
          moduleName: null,
          isHidden: null,
          status: null,
          startDate: null,
          endDate: null,
          publishType: null,
          isExpire: null,
          permissionType: null,
          riskLevel: null,
          fundCodes: null,
          proNatures: null,
          attachment:
            '国泰君安君得利集合资产管理计划2017年第4季度管理人报告.pdf',
          reason: null,
          importState: '导入成功',
        },
        {
          pageNo: 1,
          pageSize: 10,
          id: '1508362465989697538',
          title: '国泰君安君得利集合资产管理计划2017年第4季度托管人报告',
          category: '普通公告',
          noticeType: null,
          regularType: null,
          fundCode: 'V33333',
          content: '请详见附件内容！',
          successNumber: 2,
          failNumber: 0,
          publishTime: '2022-04-01',
          parentFundCode: null,
          channelCode: '产品公告',
          columnCode: null,
          isReview: null,
          moduleName: null,
          isHidden: null,
          status: null,
          startDate: null,
          endDate: null,
          publishType: null,
          isExpire: null,
          permissionType: null,
          riskLevel: null,
          fundCodes: null,
          proNatures: null,
          attachment:
            '国泰君安君得利集合资产管理计划2017年第4季度托管人报告.pdf',
          reason: null,
          importState: '导入成功',
        },
        {
          pageNo: 1,
          pageSize: 10,
          id: '1508362465989697539',
          title: '国泰君安君享新三板2号集合资产管理计划2017年第4季度托管人报告',
          category: '普通公告',
          noticeType: null,
          regularType: null,
          fundCode: '952080',
          content: '请详见附件内容！',
          successNumber: 3,
          failNumber: 0,
          publishTime: '2022-04-07',
          parentFundCode: null,
          channelCode: '关于我们',
          columnCode: null,
          isReview: null,
          moduleName: null,
          isHidden: null,
          status: null,
          startDate: null,
          endDate: null,
          publishType: null,
          isExpire: null,
          permissionType: null,
          riskLevel: null,
          fundCodes: null,
          proNatures: null,
          attachment:
            '国泰君安君享新三板2号集合资产管理计划2017年第4季度托管人报告.pdf',
          reason: null,
          importState: '导入成功',
        },
      ],
      currentKey: 1, //当前操作标志位
    };
  },
  methods: {
    handleVisible() {
      this.visible = !this.visible;
    },
    saveData() {
      let url =
        process.env.VUE_APP_LOCAL_PATH +
        '/' +
        process.env.VUE_APP_CMS_CONTENT +
        `/content/notice/confirmImport`;
      jsonAction(url, this.dataSource, 'post').then((res) => {
        console.log(res, '+++++++++++');
      });
    },
    // 文件上传
    beforeUpload(file) {
      this.fileList = [
        {
          uid: file.uid,
          name: file.name,
          createdTime: file.lastModifiedDate,
          size: file.size,
        },
      ];
      return false;
    },
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleFileChange(info) {
      console.log(info);
      const { file, fileList } = info;
      let status = file.status;
      if (status == 'done') {
        let res = file.response;
        if (res.success) {
          this.$message.success('上传成功！');
          console.log(res, '+++++++');
          this.currentKey = 2;
          this.dataSource = res.result ? res.result : [];
        } else {
          this.dataSource = [];
        }
      } else {
        this.fileList = [...fileList];
      }
    },
    handleOk() {
      if (this.currentKey == 1) {
        this.saveData();
      } else {
        this.currentKey = 1;
      }
    },
    onDelete(id) {
      let index = this.dataSource.findIndex((item) => item.id == id);
      this.dataSource.splice(index, 1);
      console.log(this.dataSource, '*************');
    },
  },
};
</script>
